import React, { useMemo, useState } from 'react';
import { useChangeOrders } from '../../hooks/useChangeOrders';
import ChangeOrderSummaryBar from './ChangeOrderSummaryBar';
import ChangeOrderList from './ChangeOrderList';
import ChangeOrderDrawer from './ChangeOrderDrawer';
import { useProjectAccessCtx } from 'src/features/projects/ProjectAccessContext';
import { hasPerm } from 'src/features/projects/hooks/useProjectAccess';

export default function ChangeOrderPage({ projectId, contractId }: { projectId: string; contractId: string }) {
    // 권한
    const { access, isLoading: accessLoading } = useProjectAccessCtx();
    const canEditContract = useMemo(() => !accessLoading && hasPerm(access?.permissions, 'contract.edit'), [accessLoading, access]);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [mode, setMode] = useState<'create' | 'edit'>('edit');

    const listQ = useChangeOrders(projectId, contractId, true);

    const rows = useMemo(() => listQ.data ?? [], [listQ.data]);

    const openCreate = () => {
        setMode('create');
        setSelectedId(null);
        setDrawerOpen(true);
    };

    const openEdit = (id: string) => {
        setMode('edit');
        setSelectedId(id);
        setDrawerOpen(true);
    };

    return (
        <section className="space-y-3">
            <ChangeOrderSummaryBar projectId={projectId} contractId={contractId} onCreate={openCreate} canEdit={canEditContract} />

            <ChangeOrderList
                rows={rows}
                loading={listQ.isLoading}
                onRowClick={(id) => openEdit(id)}
                onCreate={openCreate}
                canEdit={canEditContract}
                actionLabel="상세 보기"
            />

            <ChangeOrderDrawer
                open={drawerOpen}
                mode={mode}
                projectId={projectId}
                contractId={contractId}
                changeOrderId={selectedId}
                onClose={() => setDrawerOpen(false)}
                canEdit={canEditContract}
            />
        </section>
    );
}
